import React from 'react'
import SupportTextNew from 'presentation/shared/components/SupportTextNew'
import { ReactComponent as NewDoctorMyProductivityIllustration } from 'presentation/assets/icons/new-doctor-my-productivity.svg'
import * as S from './styles'
import moment from 'moment-timezone'
import { useHistory } from 'react-router'
import HeadingNew from 'presentation/shared/components/HeadingNew'

type BannerMyProductivityProps = {
  date: Date
}

const NewBannerMyProductivity = ({ date }: BannerMyProductivityProps) => {
  const history = useHistory()

  return (
    <S.Wrapper onClick={() => history.push('/minhas-cirurgias')}>
      <NewDoctorMyProductivityIllustration />

      <S.TextWrapper>
        <SupportTextNew
          uppercase
          weight="bold"
          color="primary600"
          size="xxsmall"
          style={{ marginTop: '15px', marginBottom: '8px' }}
        >
          {moment(date).format('MMMM [de] YYYY')}
        </SupportTextNew>
        <HeadingNew
          as="h3"
          weight="bold"
          color="neutral700"
          size="large"
          style={{ marginBottom: '9px', width: '10px' }}
        >
          Minhas cirurgias
        </HeadingNew>
        <SupportTextNew
          style={{ marginBottom: '9px' }}
          weight="semiBold"
          color="neutral500"
          size="xxsmall"
        >
          Acompanhe sua produtividade mensal na Rede Mater Dei
        </SupportTextNew>
      </S.TextWrapper>
    </S.Wrapper>
  )
}

export default NewBannerMyProductivity
